<script>import Included from "../icons/included.svelte";
import { getVerbiageKey } from "../utils";
import { t, Verbiage } from "@infinitro/content";
import { UpIcon } from "@infinitro/icons";
import { Icon } from "@infinitro/rank-badges";
export let rankName = "Rank Name";
export let rankBadge = "1";
export let levels = [];
const columns = [
  { name: Verbiage[getVerbiageKey("tier_name_text")], id: "tier-name" },
  { name: Verbiage[getVerbiageKey("wager_requirements")], id: "wager-requirements" },
  { name: Verbiage[getVerbiageKey("rakeback_text")], id: "rakeback" },
  { name: Verbiage[getVerbiageKey("rakeboost_text")], id: "rakeboost" },
  { name: Verbiage[getVerbiageKey("level_up_reward_text")], id: "level-up-reward" },
  { name: Verbiage[getVerbiageKey("daily_bonuses_text")], id: "daily-bonuses" },
  { name: Verbiage[getVerbiageKey("weekly_bonuses_text")], id: "weekly-bonuses" },
  { name: Verbiage[getVerbiageKey("monthly_bonuses_text")], id: "monthly-bonuses" },
  { name: Verbiage[getVerbiageKey("calendar_claimable_days")], id: "calendar-claimable-days" }
];
const processedLevels = levels.map((level, i) => ({
  ...level,
  displayLevel: i + 1 <= 5 ? i + 1 : void 0
}));
</script>

<div class="rank-table">
	<div class="header-row">
		{#each columns as column, index}
			<div
				class="header-cell {index === 0
					? 'first-column'
					: index === columns.length - 1
						? 'last-column'
						: ''}"
			>
				{$t(column.name)}
			</div>
		{/each}
	</div>
	{#each processedLevels as level}
		<div class="body-row">
			<div class="body-cell td-name">
				<Icon rank={rankBadge} level={level.displayLevel} size={20} />
				<span>{$t(Verbiage[rankName.toLowerCase()])} {level.level}</span>
			</div>
			{#each columns.slice(1) as column}
				<div class="body-cell">
					{#if column.id === 'level-up-reward'}
						${level.levelUpReward}
					{:else if column.id === 'calendar-claimable-days'}
						{level.calendarClaimableDays} {$t(Verbiage[getVerbiageKey('days')])}
					{:else if column.id === 'wager-requirements'}
						${level.wagerRequirements}
					{:else}
						<Included />
					{/if}
					{#if level !== '' && column.id !== 'calendar-claimable-days' && column.id !== 'wager-requirements' && column.id !== 'level-up-reward'}
						<UpIcon />
					{/if}
				</div>
			{/each}
		</div>
	{/each}
</div>

<style>
	.rank-table {
		margin-top: 1.25rem;
		margin-bottom: 1.25rem;
		width: 100%;
		min-width: 1000px;
		font-family: var(--font-main)
}
	.header-row,
	.body-row {
		display: flex
}
	.header-cell,
	.body-cell {
		padding: 0.5rem;
		padding-right: 1rem;
		text-align: left;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity))
}
	.header-row {
		margin-bottom: 0.5rem;
		display: flex;
		align-items: center;
		border-radius: 0.5rem;
		background-color: var(--color-background-500)
}
	.body-row {
		display: flex;
		align-items: center;
		border-radius: 0.5rem;
		border-width: 1px;
		border-color: var(--color-neutral-900)
}
	.header-cell,
	.body-cell {
		width: 10.625%
}
	.header-cell {
		opacity: 0.5;
		font-family: var(--font-main);
		font-weight: 400
}
	.header-cell.first-column {
		width: 15%;
		border-top-left-radius: 0.5rem;
		border-bottom-left-radius: 0.5rem
}
	.header-cell.last-column {
		border-top-right-radius: 0.5rem;
		border-bottom-right-radius: 0.5rem
}
	img {
		margin-right: 0.5rem;
		display: inline-block;
		width: 1.25rem
}
	.td-name {
		display: flex;
		width: 15%;
		align-items: center;
		gap: 0.25rem
}
</style>
